/**
 * Sticky Buttons - Shows a sticky clone of product-form__custom-buttons
 * when the original is not visible on screen
 */
(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Only run on mobile view (max-width: 749px)
    if (window.innerWidth > 749) {
      return; // Skip on desktop
    }

    const originalButtons = document.querySelector('.product-form__custom-buttons');
    
    if (!originalButtons) {
      return; // Element doesn't exist on this page
    }

    let stickyClone = null;
    let observer = null;

    // Create sticky clone
    function createStickyClone() {
      if (stickyClone) {
        return; // Already created
      }

      stickyClone = originalButtons.cloneNode(true);
      stickyClone.classList.add('product-form__custom-buttons--sticky');
      stickyClone.style.display = 'none'; // Initially hidden
      document.body.appendChild(stickyClone);

      // Re-attach event listeners for form submission
      const stickyForm = stickyClone.querySelector('form');
      const originalForm = originalButtons.querySelector('form');
      
      if (stickyForm && originalForm) {
        stickyForm.addEventListener('submit', function(e) {
          e.preventDefault();
          e.stopPropagation();
          // Trigger submit on original form
          if (originalForm.requestSubmit) {
            originalForm.requestSubmit();
          } else {
            originalForm.submit();
          }
        });
      }

      // Re-attach click handlers for submit buttons
      const stickySubmitBtn = stickyClone.querySelector('.product-form__submit');
      const originalSubmitBtn = originalButtons.querySelector('.product-form__submit');
      
      if (stickySubmitBtn && originalSubmitBtn) {
        stickySubmitBtn.addEventListener('click', function(e) {
          // If button is inside a form, let form handler deal with it
          if (!stickySubmitBtn.closest('form')) {
            e.preventDefault();
            originalSubmitBtn.click();
          }
        });
      }

      // Re-attach click handlers for other buttons (wishlist, social, etc.)
      const stickyOtherButtons = stickyClone.querySelectorAll('.product-form__wishlist-button, .product-form__social-button');
      const originalOtherButtons = originalButtons.querySelectorAll('.product-form__wishlist-button, .product-form__social-button');
      
      stickyOtherButtons.forEach((stickyBtn, index) => {
        if (originalOtherButtons[index]) {
          const button = stickyBtn.querySelector('button, a');
          const originalButton = originalOtherButtons[index].querySelector('button, a');
          
          if (button && originalButton) {
            button.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              originalButton.click();
            });
          }
        }
      });
    }

    // Update sticky clone content to match original
    function updateStickyClone() {
      if (!stickyClone) return;
      
      // Update button states
      const originalSubmitBtn = originalButtons.querySelector('.product-form__submit');
      const stickySubmitBtn = stickyClone.querySelector('.product-form__submit');
      
      if (originalSubmitBtn && stickySubmitBtn) {
        stickySubmitBtn.disabled = originalSubmitBtn.disabled;
        stickySubmitBtn.innerHTML = originalSubmitBtn.innerHTML;
      }

      // Update variant ID input
      const originalVariantInput = originalButtons.querySelector('.product-variant-id');
      const stickyVariantInput = stickyClone.querySelector('.product-variant-id');
      
      if (originalVariantInput && stickyVariantInput) {
        stickyVariantInput.value = originalVariantInput.value;
        stickyVariantInput.disabled = originalVariantInput.disabled;
      }
    }

    // Show sticky clone
    function showStickyClone() {
      if (!stickyClone) {
        createStickyClone();
      }
      updateStickyClone();
      stickyClone.style.display = '';
    }

    // Hide sticky clone
    function hideStickyClone() {
      if (stickyClone) {
        stickyClone.style.display = 'none';
      }
    }

    // Setup IntersectionObserver
    function setupObserver() {
      const options = {
        root: null, // Use viewport as root
        rootMargin: '0px',
        threshold: 0 // Trigger when any part enters/leaves viewport
      };

      observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            // Element is visible
            hideStickyClone();
          } else {
            // Element is not visible
            showStickyClone();
          }
        });
      }, options);

      observer.observe(originalButtons);
    }

    // Watch for variant changes to update sticky clone
    function watchVariantChanges() {
      // Listen for variant change events
      document.addEventListener('variant:change', function() {
        updateStickyClone();
      });

      // Also watch for changes in the variant input
      const variantInput = originalButtons.querySelector('.product-variant-id');
      if (variantInput) {
        const variantObserver = new MutationObserver(function() {
          updateStickyClone();
        });
        
        variantObserver.observe(variantInput, {
          attributes: true,
          attributeFilter: ['value', 'disabled']
        });
      }

      // Watch for button state changes
      const submitButton = originalButtons.querySelector('.product-form__submit');
      if (submitButton) {
        const buttonObserver = new MutationObserver(function() {
          updateStickyClone();
        });
        
        buttonObserver.observe(submitButton, {
          attributes: true,
          childList: true,
          subtree: true,
          attributeFilter: ['disabled']
        });
      }
    }

    // Initialize
    createStickyClone();
    setupObserver();
    watchVariantChanges();

    // Handle window resize - cleanup if switching to desktop
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        if (window.innerWidth > 749) {
          // Desktop view - cleanup
          if (observer) {
            observer.disconnect();
          }
          if (stickyClone && stickyClone.parentNode) {
            stickyClone.parentNode.removeChild(stickyClone);
            stickyClone = null;
          }
        }
      }, 250);
    });

    // Cleanup on page unload
    window.addEventListener('beforeunload', function() {
      if (observer) {
        observer.disconnect();
      }
      if (stickyClone && stickyClone.parentNode) {
        stickyClone.parentNode.removeChild(stickyClone);
      }
    });
  }
})();

